import enterpreactivity1 from "../../../assets/CampuLifeImages/enterpreactivity1.jpeg"
import enterpreactivity2 from "../../../assets/CampuLifeImages/enterpreactivity2.jpeg"
import enterpreactivity3 from "../../../assets/CampuLifeImages/enterpreactivity3.jpeg"
import enterpreactivity4 from "../../../assets/CampuLifeImages/enterpreactivity4.jpeg"
import CampusSkillEnhanceDynamic from '../../CampusSharedComponent/CampusDynamicPages/CampusSkillEnhanceDynamicPage/CampusSkillEnhanceDynamic';



const Enterpreneurship = () => {

  const hoverContent =[
    {  img: enterpreactivity1, para1: "Studentpreneur Award Celebration", para2: "August 23, 2024" },
    {  img: enterpreactivity2, para1: "Entrepreneur day Celebration   Celebration", para2: "August 21, 2024" },
    {  img: enterpreactivity3, para1: "Beautician Course", para2: "March 15, 2024" },
    {  img: enterpreactivity4, para1: "College 	bazar", para2: "January 22, 2024" }
]

const data = {
  name: "Entrepreneurship Development Cell", 
  title: "Entrepreneurship Development Cell Activities",
  viewmore:"true",
  viewless:"true",
  para:"Economic development of a country is supported by entrepreneurship in several ways. It is a key contributor to innovativeness and product improvement and a pivotal ingredient to employment creation. Another important aspect to be considered is that in the context of the Indian market, entrepreneurship led economic growth is more inclusive and hence Governments, both at Centre and State level, have been taking initiatives to boost the entrepreneurial ecosystem as they realize the benefits entrepreneurship brings to the economic growth of the country. The ED Cell of the College conducts various awareness programmes such as Seminars, Workshops, Industrial Visits, Food Fest and Interaction with young Entrepreneurs etc. These programmes are aimed at making the student community more enthusiastic towards entrepreneurial activity. The Advisory board for the ED cell comprises of members from industry, financial institutions, Research and Development, Government institutions etc. The board will guide and advise the cell in organizing various activities.",
  contentparaTitle:"Vision & Mission :",
  contentpara:"The mission of the Entrepreneurship Development Cell (ED Cell) is to inspire and empower aspiring entrepreneurs by fostering innovation, creativity, and business skills. It aims to provide mentorship, training, and resources to help students develop entrepreneurial mindsets and turn ideas into successful ventures. Through workshops, competitions, and networking opportunities, the ED Cell creates a supportive ecosystem that nurtures startups and encourages problem-solving, leadership, and self-reliance.",
  fourhover:true
}
  
  return (
    <>
    
     <CampusSkillEnhanceDynamic data={data} content={hoverContent} />
     
    </>
  )
}

export default Enterpreneurship